import {
  ArrowLeft,
  ArrowRight,
  Baby,
  Armchair,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Coffee,
  Filter,
  Gem,
  Grid3x3,
  Heart,
  Info,
  Lamp,
  Leaf,
  List,
  MapPin,
  NotebookPen,
  Palette,
  Search,
  Shirt,
  ShoppingBag,
  Sparkles,
  Star,
  Tent,
  Utensils,
  X,
} from 'lucide-angular';

/**
 * Curated Lucide icon registry used across VendorHub. Keep this set small
 * and intentional: every additional icon is extra bundle weight. Add a
 * new icon here only when a new surface needs it.
 */
export const VH_LUCIDE_ICONS = {
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  armchair: Armchair,
  baby: Baby,
  check: Check,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  coffee: Coffee,
  filter: Filter,
  gem: Gem,
  grid: Grid3x3,
  heart: Heart,
  info: Info,
  lamp: Lamp,
  leaf: Leaf,
  list: List,
  'map-pin': MapPin,
  'notebook-pen': NotebookPen,
  palette: Palette,
  search: Search,
  shirt: Shirt,
  'shopping-bag': ShoppingBag,
  sparkles: Sparkles,
  star: Star,
  tent: Tent,
  utensils: Utensils,
  x: X,
} as const;

export type VhIconName = keyof typeof VH_LUCIDE_ICONS;
